import { useState, useEffect } from 'react'
import { PortfolioService, PORTFOLIO_FIELDS, type StudentPortfolio } from '../services/portfolio'

interface Props {
  userId: string
}

const PortfolioTabContent = ({ userId }: Props) => {
  const [portfolio, setPortfolio] = useState<StudentPortfolio | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    PortfolioService.getPortfolio(userId)
      .then(setPortfolio)
      .catch((err) => console.error('Failed to load portfolio:', err))
      .finally(() => setIsLoading(false))
  }, [userId])

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500" />
      </div>
    )
  }

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-bold text-gray-900">キャリアサマリ</h2>

      <div className="border border-gray-200 rounded-lg overflow-hidden">
        <table className="w-full">
          <tbody>
            {PORTFOLIO_FIELDS.map(({ key, label }, idx) => (
              <tr key={key} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                <td className="w-40 px-4 py-3 text-sm font-medium text-gray-700 border-r border-gray-200 align-top whitespace-nowrap">
                  {label}
                </td>
                <td className="px-4 py-3 text-sm text-gray-900">
                  {portfolio?.[key] && (
                    <span className="whitespace-pre-wrap">{portfolio[key]}</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default PortfolioTabContent
